<template>
  <section class="is-full-height is-full-width" :data-e2e="GoalTestAttribute.views.GOALS">
    <div v-if="hasEarlyExit" class="has-text-primary has-text-weight-semibold m-b-30">
      <span class="is-clickable is-size-3">{{ `<<` }}</span>
      <span
        class="is-clickable is-size-4 has-text-weight-semibold"
        @click="onEarlyExitClicked"
        :data-e2e="LightDiagnosticCypressAttribute.buttons.BACK_TO_SOLUTIONS"
      >
        {{ $t('lightdiagnostic.go-back-to-solutions') }}
      </span>
    </div>
    <h1 class="is-size-2 has-text-weight-semibold has-text-black m-b-10" :class="computedClass">
      {{ $t('lightdiagnostic.what-applies-goals') }}
    </h1>
    <h2 class="subtitle has-text-black is-size-4 has-text-weight-medium">
      {{ $t('guidancestep.select-all-if-apply') }}
    </h2>
    <div class="columns m-t-10 is-multiline is-flex">
      <div class="column is-4" v-for="goal in GoalType.getValues()" :key="goal.key">
        <BoxButton
          @click="onClick(goal.key)"
          :selected="value.isGoalSelected(goal.key)"
          :centered="true"
        >
          <template #body>
            <div
              class="is-flex-direction-column is-flex-centered box-container"
              :data-e2e="GoalTestAttribute.buttons.GOAL_TYPE_BUTTON"
            >
              <i
                :class="`cls cls-${goal.icon}`"
                class="has-text-secondary-grey is-size-1 m-b-10"
              ></i>
              <p class="is-size-5" :data-e2e="GoalTestAttribute.buttons.GOAL_TYPE_BUTTON_TEXT">
                {{ $t(goal.value) }}
              </p>
            </div>
          </template>
        </BoxButton>
      </div>
    </div>
    <BaseFlowControlButtons
      :next-disabled="!jurisdictionId && showBillingPlan"
      :hide-back="hideBackButton"
      tooltip-type="is-dark"
      :tooltip-label="$t('lightdiagnostic.please-select-province')"
      :tooltip-active="!jurisdictionId && showBillingPlan"
      :show-press-enter="true"
      @next="customNext"
      @back="back"
    >
      <template #next>
        {{ showBillingPlan ? $t('lightdiagnostic.get-matched-best') : $t('asset.next') }} >>
      </template>
    </BaseFlowControlButtons>
  </section>
</template>

<script>
import { GoalType } from '@/modules/goal/enums/GoalType';
import { GoalTestAttribute } from '@/modules/goal/constants/GoalTestAttribute';
import BoxButton from '@/modules/core/ui/components/BoxButton.vue';
import BaseFlowControlButtons from '@/modules/core/form/components/BaseFlowControlButtons.vue';
import LightDiagnosticBillingPlan from '@/modules/lightdiagnostic/components/stateful/LightDiagnosticBillingPlan.vue';
import { LightDiagnosticMixin } from '@/modules/lightdiagnostic/mixins/LightDiagnosticMixin';
import { LightDiagnosticCypressAttribute } from '@/modules/lightdiagnostic/constants/LightDiagnosticCypressAttribute';
import { LightDiagnosticForm } from '@/modules/lightdiagnostic/models/LightDiagnosticForm';
import LightDiagnosticSituation from '@/modules/lightdiagnostic/components/presentational/LightDiagnosticSituation.vue';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'LightDiagnosticGoal',
  emits: ['custom-flow-change', 'flow-change', 'on-goals-input'],
  mixins: [LightDiagnosticMixin],
  components: { BaseFlowControlButtons, BoxButton },
  props: {
    value: {
      type: LightDiagnosticForm,
      required: true
    }
  },
  static: {
    LightDiagnosticCypressAttribute,
    GoalType,
    GoalTestAttribute
  },
  data() {
    return {
      form: this.value
    };
  },
  methods: {
    customNext() {
      if (!this.showBillingPlan) {
        this.$emit('custom-flow-change');
        return;
      }
      this.$emit('flow-change', LightDiagnosticBillingPlan);
    },
    back() {
      this.$emit('flow-change', LightDiagnosticSituation);
    },
    onClick(goalKey) {
      this.form.addGoalKey(goalKey);
      this.$emit('on-goals-input', this.form.goals);
    },
    isSelected(goalKey) {
      return this.form.goals.includes(goalKey);
    }
  }
};
</script>

<style scoped>
:deep(.box-container) {
  min-height: var(--ce-120px);
}

@media (max-width: 1023px) {
  .column.is-4 {
    width: 33% !important;
    flex: none !important;
  }
}

@media (max-width: 786px) {
  .column.is-4 {
    width: 100% !important;
    flex: none !important;
  }
}
</style>
